import { render, staticRenderFns } from "./fccAlteracoesColegios.vue?vue&type=template&id=cd03d6b4"
import script from "./fccAlteracoesColegios.vue?vue&type=script&lang=js"
export * from "./fccAlteracoesColegios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports